<div class="widget-container {{ size() }}" [ngClass]="{'responsive': isResponsive()}">

  <svg class="risk-icon {{variant()}}" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="hexagon 4.0">
      <path id="Exclude"
        d="M26.5074 2.08962L12.2899 0.0191774C11.6602 -0.0725291 11.0277 0.168911 10.6308 0.65255L1.66984 11.5716C1.27293 12.0552 1.17185 12.7076 1.40467 13.2829L6.66117 26.2724C6.894 26.8478 7.42536 27.2587 8.0551 27.3504L22.2726 29.4208C22.9023 29.5125 23.5348 29.2711 23.9317 28.7874L27.0728 24.96H23.217L22.5031 25.762C22.1915 26.1416 21.6951 26.3311 21.2008 26.2591L10.0405 24.6339C9.54617 24.5619 9.12907 24.2394 8.94631 23.7877L4.82012 13.5914C4.63736 13.1398 4.7167 12.6277 5.02826 12.248L12.0624 3.67694C12.3739 3.2973 12.8704 3.10778 13.3647 3.17976L24.525 4.805C25.0193 4.87699 25.4364 5.19955 25.6192 5.65117L27.0728 9.24323H30.1611L27.9013 3.16759C27.6685 2.59225 27.1371 2.18133 26.5074 2.08962Z"
        fill="var(--hexagon-color)"/>
    </g>
  </svg>

  <div class="data-wrapper">
    <div class="numerator {{ numeratorClass() }}">
      {{ numberValue() }}
    </div>

    @if (withDenominator()) {
      <div class="denominator">| 100</div>
    }
    <div class="title">{{ title() }}</div>
  </div>
</div>
